// eslint-disable-next-line
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import Home from './Home';
import Result1 from './Result1';
import Result2 from './Result2';
import Result3 from './Result3';
import Result4 from './Result4';
import { Router, Route,  IndexRoute,  browserHistory   } from 'react-router'
import registerServiceWorker from './registerServiceWorker';

//ReactDOM.render(<App />, document.getElementById('root'));


ReactDOM.render((
    <Router history={browserHistory } >
     <Route path="/" component={App}>
          <IndexRoute component={Home} />
          <Route path="masj" component={Home} />
          <Route path="masj/:lang" component={Home} />
          <Route path="my-wellness-discovery/:lang" component={Result1} />
		  <Route path="my-delightful-discovery/:lang" component={Result2} />
		  <Route path="my-lifestyle-discovery/:lang" component={Result3} />
		  <Route path="my-beauty-discovery/:lang" component={Result4} />
       </Route>
    </Router>
     
 ), document.getElementById('root'))


registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js